const SUPABASE_URL = 'https://uwrxxpidrmdzmhgmqqth.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV3cnh4cGlkcm1kem1oZ21xcXRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMDk2NDcsImV4cCI6MjEwMDg4NTY0N30.pn8L-v_3Pyxepos0rj8_CSB8IYLsoROMHdjjDnk-4VY';

window.obCurrentReviews = [];
window.obCurrentReviewsPage = 1;

window.loadOBReviews = function(handle) {
  const reviewsContainer = document.getElementById('ob-reviews-dynamic');
  if (!reviewsContainer) return;
  
  reviewsContainer.dataset.handle = handle;
  reviewsContainer.innerHTML = '<div style="padding:40px 0;text-align:center;color:#888;">Loading reviews...</div>';
  
  fetch(`${SUPABASE_URL}/rest/v1/product_reviews?product_handle=eq.${handle}&status=eq.approved&order=created_at.desc`, {
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
    }
  })
  .then(res => res.json())
  .then(data => {
    if (data && data.length > 0) {
      window.obCurrentReviews = data;
      window.obCurrentReviewsPage = 1;

      let totalRating = 0;
      let totalHours = 0;
      let hoursCount = 0;
      const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      
      data.forEach(review => {
        totalRating += review.rating;
        counts[review.rating]++;
        if (review.hours_lasting && review.hours_lasting > 0) {
          totalHours += review.hours_lasting;
          hoursCount++;
        }
      });
      
      const avg = (totalRating / data.length).toFixed(1);
      const avgHours = hoursCount > 0 ? (totalHours / hoursCount).toFixed(1) : '8.4';
      
      // Update top product rating
      const topStarsEl = document.querySelector('.rate .st');
      if (topStarsEl) topStarsEl.innerText = Array(5).fill(0).map((_, i) => i < Math.round(avg) ? '★' : '☆').join('');
      const rateTextEl = document.querySelector('.rate span[style*="600"]');
      if (rateTextEl) rateTextEl.innerText = avg;
      
      const reviewLink = document.querySelector('.rate a[href="#obv12-reviews"]');
      if (reviewLink) {
        reviewLink.innerText = data.length + ' Reviews';
        // Make sure the event listener is only added once (or just let CSS handle smooth scroll if not needed)
      }

      // Generate Stats HTML
      let html = `
        <div class="rv-top">
          <div class="rv-sc">${avg}</div>
          <div class="rv-bars">
            <div class="rv-b"><span>5</span><span class="t"><i style="width:${Math.round((counts[5]/data.length)*100)}%"></i></span><span>${Math.round((counts[5]/data.length)*100)}%</span></div>
            <div class="rv-b"><span>4</span><span class="t"><i style="width:${Math.round((counts[4]/data.length)*100)}%"></i></span><span>${Math.round((counts[4]/data.length)*100)}%</span></div>
            <div class="rv-b"><span>3</span><span class="t"><i style="width:${Math.round((counts[3]/data.length)*100)}%"></i></span><span>${Math.round((counts[3]/data.length)*100)}%</span></div>
            <div class="rv-b"><span>2</span><span class="t"><i style="width:${Math.round((counts[2]/data.length)*100)}%"></i></span><span>${Math.round((counts[2]/data.length)*100)}%</span></div>
            <div class="rv-b"><span>1</span><span class="t"><i style="width:${Math.round((counts[1]/data.length)*100)}%"></i></span><span>${Math.round((counts[1]/data.length)*100)}%</span></div>
          </div>
        </div>
        <div class="rv-stats">
          <div class="rv-s"><div class="n">${avgHours} hrs</div><div class="l">Avg longevity</div></div>
          <div class="rv-s"><div class="n">91%</div><div class="l">Got a compliment</div></div>
          <div class="rv-s"><div class="n">62%</div><div class="l">Bought a second</div></div>
        </div>
        <div id="ob-rv-list-wrap"></div>
        <div id="ob-rv-load-more-wrap" style="text-align:center; margin-top:20px; display:flex; justify-content:center; gap:10px; display:none;">
          <button id="ob-rv-load-more-btn" style="background:transparent; border:1px solid #4a3e35; color:#4a3e35; padding:12px 24px; cursor:pointer; text-transform:uppercase; font-size:11px; letter-spacing:2px; transition:all 0.3s ease;">Load More Reviews</button>
          <button id="ob-rv-view-less-btn" style="background:transparent; border:1px solid #4a3e35; color:#4a3e35; padding:12px 24px; cursor:pointer; text-transform:uppercase; font-size:11px; letter-spacing:2px; transition:all 0.3s ease; display:none;">View Less</button>
        </div>
      `;
      
      reviewsContainer.innerHTML = html;
      
      const loadBtn = document.getElementById('ob-rv-load-more-btn');
      if (loadBtn) {
        loadBtn.addEventListener('click', function() {
          window.obCurrentReviewsPage++;
          renderReviewPage();
        });
        loadBtn.addEventListener('mouseover', function() { this.style.background = '#4a3e35'; this.style.color = '#fff'; });
        loadBtn.addEventListener('mouseout', function() { this.style.background = 'transparent'; this.style.color = '#4a3e35'; });
      }

      const lessBtn = document.getElementById('ob-rv-view-less-btn');
      if (lessBtn) {
        lessBtn.addEventListener('click', function() {
          window.obCurrentReviewsPage = 1;
          renderReviewPage();
          document.getElementById('obv12-reviews').scrollIntoView({ behavior: 'smooth' });
        });
        lessBtn.addEventListener('mouseover', function() { this.style.background = '#4a3e35'; this.style.color = '#fff'; });
        lessBtn.addEventListener('mouseout', function() { this.style.background = 'transparent'; this.style.color = '#4a3e35'; });
      }

      renderReviewPage();
      
    } else {
      const topStarsEl = document.querySelector('.rate .st');
      if (topStarsEl) topStarsEl.innerText = '★★★★★';
      const rateTextEl = document.querySelector('.rate span[style*="600"]');
      if (rateTextEl) rateTextEl.innerText = '5.0';
      const reviewLink = document.querySelector('.rate a[href="#obv12-reviews"]');
      if (reviewLink) reviewLink.innerText = '0 Reviews';
      
      reviewsContainer.innerHTML = '<div style="padding:20px 0;color:#666;">No reviews yet. Be the first to review!</div>';
    }
  })
  .catch(err => {
    console.error('Failed to load reviews', err);
    reviewsContainer.innerHTML = '<div style="padding:20px 0;color:#c62828;">Failed to load reviews.</div>';
  });
};

function renderReviewPage() {
  const wrap = document.getElementById('ob-rv-list-wrap');
  const loadWrap = document.getElementById('ob-rv-load-more-wrap');
  if (!wrap) return;
  
  const perPage = 5;
  const toShow = window.obCurrentReviews.slice(0, window.obCurrentReviewsPage * perPage);
  
  let html = '';
  toShow.forEach(review => {
    const stars = Array(5).fill(0).map((_, i) => i < review.rating ? '★' : '☆').join('');
    html += `
    <div class="rev">
      <div class="s">${stars}</div>
      <div class="t">${review.body || ''}</div>
      <div class="m"><span class="vb">✓ Verified</span> ${review.author_name}</div>
    </div>
    `;
  });
  
  wrap.innerHTML = html;
  
  if (loadWrap) {
    const loadBtn = document.getElementById('ob-rv-load-more-btn');
    const lessBtn = document.getElementById('ob-rv-view-less-btn');
    
    let showWrap = false;
    
    if (window.obCurrentReviews.length > toShow.length) {
      if (loadBtn) loadBtn.style.display = 'block';
      showWrap = true;
    } else {
      if (loadBtn) loadBtn.style.display = 'none';
    }
    
    if (window.obCurrentReviewsPage > 1) {
      if (lessBtn) lessBtn.style.display = 'block';
      showWrap = true;
    } else {
      if (lessBtn) lessBtn.style.display = 'none';
    }
    
    loadWrap.style.display = showWrap ? 'flex' : 'none';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const reviewsContainer = document.getElementById('ob-reviews-dynamic');
  if (reviewsContainer) {
    window.loadOBReviews(reviewsContainer.dataset.handle);
    
    // Setup initial smooth scroll listener for the top Reviews link
    const reviewLink = document.querySelector('.rate a[href="#obv12-reviews"]');
    if (reviewLink) {
      reviewLink.addEventListener('click', function(e) {
        e.preventDefault();
        const t = document.getElementById('obv12-reviews');
        if (t) t.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  // Submit new review
  const reviewForm = document.getElementById('ob-review-form');
  if (reviewForm) {
    reviewForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const submitBtn = reviewForm.querySelector('button[type="submit"]');
      const msgEl = document.getElementById('ob-review-msg');
      const productHandle = document.getElementById('ob-reviews-dynamic').dataset.handle;
      
      submitBtn.disabled = true;
      submitBtn.innerText = 'Submitting...';
      msgEl.innerHTML = '';
      
      const formData = new FormData(reviewForm);
      const payload = {
        product_handle: productHandle,
        rating: parseInt(formData.get('rating')),
        title: formData.get('title'),
        body: formData.get('body'),
        author_name: formData.get('author_name'),
        hours_lasting: parseInt(formData.get('hours_lasting') || 0),
        status: 'pending'
      };
      
      fetch(`${SUPABASE_URL}/rest/v1/product_reviews`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
          'Prefer': 'return=minimal'
        },
        body: JSON.stringify(payload)
      })
      .then(res => {
        if (res.ok) {
          msgEl.innerHTML = '<span style="color:#2e7d32;display:block;padding:15px;background:#e8f5e9;border-radius:8px;font-weight:500;">Thank you! Your review has been submitted and is pending approval.</span>';
          reviewForm.reset();
          reviewForm.style.display = 'none';
        } else {
          throw new Error('Server error');
        }
      })
      .catch(err => {
        msgEl.innerHTML = '<span style="color:#c62828;display:block;padding:15px;background:#ffebee;border-radius:8px;font-weight:500;">Failed to submit review. Please try again.</span>';
      })
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.innerText = 'Submit Review';
      });
    });
  }
});
